import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./loader";

const InquiryForm = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [messageClass, setMessageClass] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoading, setIsLoading] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [formData, setFormData] = useState({
    FullName: "",
    Email: "",
    MobileNo: "",
    Service: [],
    Message: "",
  });

  useEffect(() => {
    const setMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name='${name}']`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute("content", content);
    };

    // Set for all major bots
    setMetaTag("robots", "noindex, nofollow");
    setMetaTag("googlebot", "noindex, nofollow");
    setMetaTag("bingbot", "noindex, nofollow");
  }, []);

  useEffect(() => {
    const handlePageLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    return () => window.removeEventListener("load", handlePageLoad);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (
      submitMessage === "Please correct the errors in the form*" &&
      validateForm()
    ) {
      setSubmitMessage("");
      setMessageClass("");
    }
  }, [formData, isChecked]); // watch all fields and checkbox

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!/^[A-Za-z ]+$/.test(formData.FullName)) {
      newErrors.FullName = "Only letters are allowed*";
      isValid = false;
    } else if (formData.FullName.length > 25) {
      newErrors.FullName = "Maximum 25 characters allowed*";
      isValid = false;
    }

    if (!formData.Email.trim()) {
      newErrors.Email = "Email is required*";
      isValid = false;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.Email)
    ) {
      newErrors.Email = "Please enter a valid email*";
      isValid = false;
    }

    if (formData.Service.length === 0) {
      // Changed to check array length
      newErrors.Service = "Please select at least one service*";
      isValid = false;
    }

    if (!formData.MobileNo.trim()) {
      newErrors.MobileNo = "Mobile number is required*";
      isValid = false;
    } else if (!/^[0-9]{10}$/.test(formData.MobileNo)) {
      newErrors.MobileNo = "Please enter a valid 10-digit number*";
      isValid = false;
    }

    if (!isChecked) {
      newErrors.terms = "You must accept the terms and conditions*";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (name === "FullName") {
      if (!/^[A-Za-z ]*$/.test(value)) {
        error = "Only letters are allowed";
      } else if (value.length > 25) {
        error = "Maximum 25 characters allowed";
      }
    } else if (name === "Email") {
      if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
        error = "Please enter a valid email";
      }
    } else if (name === "MobileNo") {
      if (value && !/^[0-9]{0,10}$/.test(value)) {
        error = "Only numbers allowed (max 10 digits)";
      }
    } else if (name === "Message") {
      if (value.length > 200) {
        error = "Maximum 200 characters allowed";
      }
    }

    setErrors({
      ...errors,
      [name]: error,
    });

    setFormData({
      ...formData,
      [name]: name === "MobileNo" ? formatNumber(value) : value,
    });
  };

  const handleServiceChange = (e) => {
    const { id, checked } = e.target;
    const updatedServices = checked
      ? [...formData.Service, id]
      : formData.Service.filter((service) => service !== id);

    setFormData({
      ...formData,
      Service: updatedServices,
    });

    // Clear service error when a selection is made
    if (updatedServices.length > 0 && errors.Service) {
      setErrors({
        ...errors,
        Service: "",
      });
    }
  };

  const formatNumber = (value) => {
    return value.replace(/\D/g, "").slice(0, 10);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setSubmitMessage("Please correct the errors in the form*");
      setMessageClass("showerror");
      return;
    }

    setLoading(true);

    const submissionData = {
      ...formData,
      Message: formData.Message || "NA",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/submitInquiry`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submissionData),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setSubmitMessage("Your form has been submitted successfully!");
      setMessageClass("showerror");

      // Reset form after successful submission
      setFormData({
        FullName: "",
        Email: "",
        MobileNo: "",
        Service: [],
        Message: "",
      });
      setIsChecked(false);
      window.location.href = "/thankyou";
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitMessage("Failed to submit form. Please try again later.");
      setMessageClass("showerror");
    } finally {
      setLoading(false); // Hide loader
      setTimeout(() => {
        setSubmitMessage("");
      }, 5000);
    }
  };
  useEffect(() => {
    const hasErrors = Object.values(errors).some((err) => err);
    if (
      !hasErrors &&
      submitMessage === "Please correct the errors in the form"
    ) {
      setSubmitMessage("");
      setMessageClass("");
    }
  }, [errors]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section class="py-5 bg-primary-gradient">
      <div class="container py-5">
        <div class="row g-5 align-items-center" id="inquiry">
          <div class="col-lg-6 text-white">
            <h2 class="mb-4 animate-on-scroll">Key Features</h2>
            <p class="mb-4 animate-on-scroll">
              Commence with confidence, guided by esteemed immigration experts
              in your vicinity.
            </p>

            <div class="animate-on-scroll">
              <div class="process-steps">
                <div class="process-step key-step">
                  <i
                    class="fas fa-check-circle fa-2x text-accent me-3"
                    style={{ marginTop: "20px" }}
                  ></i>

                  <div class="step-content">
                    <h4 class="text-white">Do It Yourself</h4>
                    <p>With help of USCIS instructions and tips</p>
                  </div>
                </div>
                <div class="process-step key-step">
                  <i
                    class="fas fa-check-circle fa-2x text-accent me-3"
                    style={{ marginTop: "20px" }}
                  ></i>
                  <div class="step-content">
                    <h4 class="text-white">Get Legal Help</h4>
                    <p>Use services of a licensed immigration attorney</p>
                  </div>
                </div>
                <div class="process-step key-step">
                  <i
                    class="fas fa-check-circle fa-2x text-accent me-3"
                    style={{ marginTop: "20px" }}
                  ></i>

                  <div class="step-content">
                    <h4 class="text-white">Request Assistance</h4>
                    <p>From accredited Representatives</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-lg-6"
            id="requestform"
            style={{ scrollMarginTop: "100px" }}
          >
            <div class="inquiry-form animate-on-scroll">
              <div class="text-center mb-4">
                <h3 class="requestcallback">Request CallBack</h3>
                <p class="text-white">
                  Fill out the form and we'll contact you shortly
                </p>
              </div>
              <div className="contact-content">
                <form onSubmit={handleSubmit} className="inquiryform">
                  <div class="mb-3">
                    <label for="name" class="form-label">
                      Full Name*
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Enter your full name"
                      name="FullName"
                      value={formData.FullName}
                      onChange={handleChange}
                    />
                    {errors.FullName && (
                      <small className="showerror">{errors.FullName}</small>
                    )}
                  </div>

                  <div class="mb-3">
                    <label for="email" class="form-label">
                      Email Address*
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      placeholder="Enter your email"
                      name="Email"
                      value={formData.Email}
                      onChange={handleChange}
                    />
                    {errors.Email && (
                      <small className="showerror">{errors.Email}</small>
                    )}
                  </div>

                  <div class="mb-3">
                    <label for="phone" class="form-label">
                      Phone Number*
                    </label>
                    <input
                      type="tel"
                      class="form-control"
                      id="phone"
                      placeholder="Enter your phone number"
                      name="MobileNo"
                      value={formData.MobileNo}
                      onChange={handleChange}
                    />
                    {errors.MobileNo && (
                      <small className="showerror">{errors.MobileNo}</small>
                    )}
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Service Interest*</label>
                    <div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="greencard-renewal"
                          onChange={handleServiceChange}
                          checked={formData.Service.includes(
                            "greencard-renewal"
                          )}
                        />
                        <label class="form-check-label" for="greencard-renewal">
                          Green Card Renewal/Lost/Damage/etc{" "}
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="family-based"
                          onChange={handleServiceChange}
                          checked={formData.Service.includes("family-based")}
                        />
                        <label class="form-check-label" for="family-based">
                          Family-Based Green Card
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="citizenship"
                          onChange={handleServiceChange}
                          checked={formData.Service.includes("citizenship")}
                        />
                        <label class="form-check-label" for="citizenship">
                          Citizenship/Naturalization
                        </label>
                      </div>
                      {errors.Service && (
                        <div className="d-block showerror">
                          {errors.Service}
                        </div>
                      )}
                    </div>
                  </div>

                  <div class="mb-4">
                    <label for="message" class="form-label">
                      How can we help?
                    </label>
                    <textarea
                      class="form-control"
                      id="message"
                      rows="4"
                      placeholder="Tell us more..."
                      name="Message"
                      value={formData.Message}
                      onChange={handleChange}
                    />
                    {errors.Message && <div>{errors.Message}</div>}
                  </div>
                  <div
                    style={{
                      marginBottom: "10px",
                    }}
                    className="policies"
                  >
                    <label className="ptd-lable-form">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="greencard-renewal"
                        style={{
                          marginRight: "10px",
                        }}
                        checked={isChecked}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setIsChecked(checked);

                          // Update error message immediately
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            terms: checked
                              ? ""
                              : "You must accept the terms and conditions",
                          }));
                        }}
                      />
                      I have read and agree to the
                      <a
                        style={{
                          margin: "0 5px",
                          color: "var(--accent)",
                        }}
                        onClick={() => navigate("/termsandconditions")}
                        className="tclink"
                        aria-label="termsandcondition"
                        href=""
                      >
                        Terms & Conditions
                      </a>
                      ,
                      <a
                        style={{
                          margin: "0 5px",
                          color: "var(--accent)",
                        }}
                        onClick={() => navigate("/privacypolicy")}
                        className="tclink"
                        aria-label="privacypolicy"
                        href=""
                      >
                        Privacy Policy
                      </a>
                      and{" "}
                      <a
                        style={{
                          margin: "0 5px",
                          color: "var(--accent)",
                        }}
                        class="tclink"
                        href=""
                        onClick={() => navigate("/disclaimer")}
                        aria-label="disclaimer"
                      >
                        Disclaimer
                      </a>
                      . We respect your privacy and your data is encrypted.
                    </label>
                    {errors.terms && (
                      <div className=" d-block showerror">{errors.terms}</div>
                    )}
                  </div>
                  <button
                    aria-label="SubmitButton"
                    type="submit"
                    class="btn w-100 py-3 btn-primary-custom"
                    disabled={loading}
                    style={{ height: "35px" }}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>{" "}
                        Sending...
                      </>
                    ) : (
                      "Send Message"
                    )}
                  </button>
                  {submitMessage && (
                    <div
                      className={messageClass}
                      style={{
                        marginTop: "15px",
                      }}
                    >
                      {submitMessage}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default InquiryForm;
